import React from 'react'
import styles from './WorkflowProgressOverlay.module.css'

/**
 * @param {{ open: boolean, badge?: string, title: string, subtitle?: string, steps?: { id: string, label: string, status: 'pending'|'active'|'done' }[], progressPercent?: number|null, footnote?: string }} props
 */
const WorkflowProgressOverlay = ({
  open,
  badge = 'En cours',
  title,
  subtitle,
  steps = [],
  progressPercent = null,
  footnote,
}) => {
  if (!open) return null

  const indeterminate = progressPercent == null

  return (
    <div className={styles.overlay} role="alertdialog" aria-busy="true" aria-live="polite">
      <div className={styles.panel}>
        <div className={styles.badge}>
          <span className={styles.badgeDot} aria-hidden="true" />
          {badge}
        </div>
        <h2 className={styles.title}>{title}</h2>
        {subtitle && <p className={styles.subtitle}>{subtitle}</p>}

        {steps.length > 0 && (
          <ul className={styles.steps}>
            {steps.map((step) => {
              const stepClass = [
                styles.step,
                step.status === 'active' ? styles.stepActive : '',
                step.status === 'done' ? styles.stepDone : '',
              ].filter(Boolean).join(' ')

              return (
                <li key={step.id} className={stepClass}>
                  <span className={styles.stepIcon} aria-hidden="true">
                    {step.status === 'done' && '✓'}
                    {step.status === 'active' && <span className={styles.stepIconInner} />}
                    {step.status === 'pending' && '·'}
                  </span>
                  <span>{step.label}</span>
                </li>
              )
            })}
          </ul>
        )}

        {!indeterminate && (
          <p className={styles.progressPercent} aria-live="polite">
            {Math.round(Math.min(100, Math.max(0, progressPercent)))}%
          </p>
        )}

        <div className={styles.progressTrack} aria-hidden="true">
          <div
            className={`${styles.progressFill} ${indeterminate ? styles.progressIndeterminate : ''}`}
            style={!indeterminate ? { width: `${Math.min(100, Math.max(0, progressPercent))}%` } : undefined}
          />
        </div>

        {footnote && <p className={styles.footnote}>{footnote}</p>}
      </div>
    </div>
  )
}

export default WorkflowProgressOverlay
